import archiveIcon from '@jetbrains/icons/archive.svg?react'
import fileIcon from '@jetbrains/icons/file.svg?react'
import folderIcon from '@jetbrains/icons/folder.svg?react'
import type {IconAttrs} from '@jetbrains/ring-ui-built/components/icon/icon'
import {SvgIcon} from '@jetbrains/teamcity-ui/dist/components'

const icons = {
  file: fileIcon,
  folder: folderIcon,
  archive: archiveIcon,
}

type Props = IconAttrs & {
  icon: keyof typeof icons
}

export default function FileTreeIcon({icon, ...restProps}: Props) {
  return <SvgIcon {...restProps} icon={icons[icon]} />
}
